/**
 * Format a number as currency in EUR
 * @param value - Number to format
 * @returns Formatted string in EUR currency format
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  }).format(value);
}
